/* ==========================================================================
   nuvदेसी Wishlist Engine (localStorage, guest-first)
   Stores { id, handle, title, image, price, url, variants[] }.
   Dispatches "wishlist:change" on any change.
   ========================================================================== */
(function () {
  const KEY = 'nuvdesi_wishlist_v1';

  function read() {
    try { return JSON.parse(localStorage.getItem(KEY)) || []; }
    catch (e) { return []; }
  }
  function write(list) {
    localStorage.setItem(KEY, JSON.stringify(list));
    document.dispatchEvent(new CustomEvent('wishlist:change', { detail: { list } }));
  }

  const Wishlist = {
    all() { return read(); },
    has(id) { id = String(id); return read().some((i) => String(i.id) === id); },
    add(item) {
      const list = read();
      if (!list.some((i) => String(i.id) === String(item.id))) { list.push(item); write(list); }
      return list;
    },
    remove(id) { id = String(id); write(read().filter((i) => String(i.id) !== id)); },
    toggle(item) {
      if (this.has(item.id)) { this.remove(item.id); return false; }
      this.add(item); return true;
    },
    count() { return read().length; },
    clear() { write([]); },
    syncToAccount() { /* future: merge to customer account */ },
  };

  function parseVariants(raw) {
    if (!raw) return [];
    try { return JSON.parse(raw); } catch (e) { return []; }
  }

  function paint() {
    const ids = read().map((i) => String(i.id));

    document.querySelectorAll('[data-wishlist-btn]').forEach((btn) => {
      const on = ids.includes(String(btn.dataset.wishlistId));
      btn.classList.toggle('is-active', on);
      btn.setAttribute('aria-pressed', on ? 'true' : 'false');
      // PDP label swap, if present
      const label = btn.querySelector('.nuv-wishlist-pdp-label');
      if (label) label.textContent = on ? 'Wishlisted' : 'Add to Wishlist';
      const al = on ? 'Remove from wishlist' : 'Add to wishlist';
      btn.setAttribute('aria-label', al);
      btn.setAttribute('title', al);
    });

    document.querySelectorAll('[data-wishlist-count]').forEach((el) => {
      const n = ids.length;
      el.textContent = n;
      el.style.display = n > 0 ? '' : 'none';
      const link = el.closest('.nuv-wl-headerlink');
      if (link) link.classList.toggle('is-active', n > 0);
    });
  }

  document.addEventListener('click', function (e) {
    const btn = e.target.closest('[data-wishlist-btn]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    Wishlist.toggle({
      id: btn.dataset.wishlistId,
      handle: btn.dataset.wishlistHandle,
      title: btn.dataset.wishlistTitle,
      image: btn.dataset.wishlistImage,
      price: btn.dataset.wishlistPrice,
      compare: btn.dataset.wishlistCompare,
      url: btn.dataset.wishlistUrl,
      variants: parseVariants(btn.dataset.wishlistVariants),
    });
  });

  document.addEventListener('wishlist:change', paint);
  document.addEventListener('DOMContentLoaded', function () {
    Wishlist.syncToAccount();
    paint();
  });

  window.Wishlist = Wishlist;
})();
